

import * as CryptoJS from 'crypto-js';


class EncrDecrService {


  // The set method is use for encrypt the value.
  set(obj) {
    const passphrase = process.env.REACT_APP_PASSPHRASE;
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const result1 = salt.toString();
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    const key = CryptoJS.PBKDF2(
      passphrase,
      salt,
      { keySize: 128 / 32, iterations: 100 });
    const plaintext = JSON.stringify(obj);
    const encrypted = CryptoJS.AES.encrypt(plaintext, key, { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let passwordpassed = result1 + iv;
    passwordpassed = passwordpassed + encrypted;
    return passwordpassed.toString();
  }

  setWithPassPhrase(obj, passphrase) {
    // const passphrase = 'BAgtAGHLCb';
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const result1 = salt.toString();
    const iv = CryptoJS.lib.WordArray.random(128 / 8);
    const key = CryptoJS.PBKDF2(
      passphrase,
      salt,
      { keySize: 128 / 32, iterations: 100 });
    const plaintext = JSON.stringify(obj);
    const encrypted = CryptoJS.AES.encrypt(plaintext, key, { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let passwordpassed = result1 + iv;
    passwordpassed = passwordpassed + encrypted;
    return passwordpassed.toString();
  }


  // The get method is use for decrypt the value.
  get(encryptedText) {
    const passphrase =  process.env.REACT_APP_PASSPHRASE;
    var salt = CryptoJS.enc.Hex.parse(encryptedText.substr(0, 32));
    var iv = CryptoJS.enc.Hex.parse(encryptedText.substr(32, 32));
    var encrypted = encryptedText.substring(64);

    var key = CryptoJS.PBKDF2(passphrase, salt, {
      keySize: 128 / 32,
      iterations: 100
    });

    var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC

    })
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  getWithPassPhrase(encryptedText, passphrase) {
    // const passphrase = 'BAgtAGHLCb';
    var salt = CryptoJS.enc.Hex.parse(encryptedText.substr(0, 32));
    var iv = CryptoJS.enc.Hex.parse(encryptedText.substr(32, 32));
    var encrypted = encryptedText.substring(64);

    var key = CryptoJS.PBKDF2(passphrase, salt, {
      keySize: 128 / 32,
      iterations: 100
    });

    var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC

    })
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  decryptTeamsite(encryptedText) {
    const passphrase = process.env.REACT_APP_PASSPHRASE;
    var salt1 = CryptoJS.enc.Hex.parse(encryptedText.substr(0, 16));
    var iv1 = CryptoJS.enc.Hex.parse(encryptedText.substr(16, 16))
    var encrypted1 = encryptedText.substring(32);

    var key1 = CryptoJS.PBKDF2(passphrase, salt1, {
      keySize: 128 / 32,
      iterations: 100
    });

    var decrypted = CryptoJS.AES.decrypt(encrypted1, key1, {
      iv: iv1,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC

    })
    return decrypted.toString(CryptoJS.enc.Utf8);
  }


  encryptedText(obj) {
    var type = typeof obj;
    var salt, iv, plaintext;
    var passphrase = process.env.REACT_APP_PASSPHRASE;
    if (type === "string") {
      salt = CryptoJS.lib.WordArray.random(128 / 16);
      iv = CryptoJS.lib.WordArray.random(128 / 16);
      plaintext = obj;
    } else {
      salt = CryptoJS.lib.WordArray.random(128 / 8);
      iv = CryptoJS.lib.WordArray.random(128 / 8);
      plaintext = JSON.stringify(obj);
    }
    var key = CryptoJS.PBKDF2(
      passphrase,
      salt,
      { keySize: 128 / 32, iterations: 100 });
    var encrypted = CryptoJS.AES.encrypt(plaintext, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    var passwordpassed = salt + iv;
    passwordpassed = passwordpassed + encrypted;
    passwordpassed = passwordpassed.replace(/(\r\n|\n|\r)/gm, "");
    return passwordpassed.toString();
  }

}
// eslint-disable-next-line
export default new EncrDecrService();